import {
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Stack,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Button,
    TextField,
    Chip,
    Autocomplete,
    Typography,
} from "@mui/material"
import { useState } from "react"
import ModalPosts from "./ModalPosts"
import { Icon } from "@iconify/react/dist/iconify.js"

function ModalTrigger({ open, handleClose, onAddTrigger, selectedConnection }) {
    const [openModalPosts, setOpenModalPosts] = useState(false)
    const [data, setData] = useState({
        triggerType: "",
        triggerCondition: "",
        keywords: [],
        posts: "all",
    })

    const handleChange = (key, value) => {
        setData({
            ...data,
            [key]: value,
        })
    }

    const onCloseClick = () => {
        setData({
            triggerType: "",
            triggerCondition: "",
            keywords: [],
        })

        handleClose()
    }

    return (
        <>
            <Dialog open={open} onClose={handleClose} fullWidth maxWidth="sm">
                <ModalPosts
                    open={openModalPosts}
                    handleClose={() => setOpenModalPosts(false)}
                    selectedConnection={selectedConnection}
                    handleConfirm={(res) => {
                        if (res.selectAll || !res.selected?.length) {
                            setData({
                                ...data,
                                posts: "all",
                            })
                            return
                        }

                        if (res.selected?.length) {
                            setData({
                                ...data,
                                posts: res.selected,
                            })
                        }
                    }}
                />
                <DialogTitle>Gatilho</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 2 }}>
                        <FormControl fullWidth>
                            <InputLabel>Tipo de Gatilho</InputLabel>
                            <Select
                                label="Tipo de Gatilho"
                                defaultValue="comment"
                                value={data.triggerType}
                                onChange={(e) =>
                                    handleChange("triggerType", e.target.value)
                                }
                            >
                                <MenuItem value={"comment"}>
                                    Comentário em publicação ou Reels
                                </MenuItem>
                                <MenuItem value={"response-story"}>
                                    Resposta ao Story
                                </MenuItem>
                                <MenuItem value={"dm-message"}>
                                    Mensagem na DM
                                </MenuItem>
                            </Select>
                        </FormControl>

                        {data.triggerType === "comment" &&
                            selectedConnection && (
                                <Button
                                    startIcon={<Icon icon="tabler:filter" />}
                                    onClick={() => setOpenModalPosts(true)}
                                    variant="outlined"
                                >
                                    {!data.posts || data.posts === "all"
                                        ? "Todos os posts"
                                        : `${data.posts?.length} posts selecionados`}
                                </Button>
                            )}

                        {data.triggerType === "comment" &&
                            !selectedConnection && (
                                <Typography variant="caption">
                                    Selecione a conexão no modal anterior para
                                    habilitar o filtro de posts
                                </Typography>
                            )}

                        <FormControl fullWidth>
                            <InputLabel>Condição</InputLabel>
                            <Select
                                label="Condição"
                                defaultValue=""
                                value={data.triggerCondition}
                                onChange={(e) =>
                                    handleChange(
                                        "triggerCondition",
                                        e.target.value,
                                    )
                                }
                            >
                                <MenuItem value={"text-exact"}>
                                    Palavra ou frase exata
                                </MenuItem>
                                <MenuItem value={"text-contains"}>
                                    Contem a palavra
                                </MenuItem>
                                <MenuItem value={"text-starts-with"}>
                                    Texto começa com
                                </MenuItem>
                                <MenuItem value={"text-ends-with"}>
                                    Texto termina com
                                </MenuItem>
                                <MenuItem value={"any-message"}>
                                    Qualquer mensagem ou interação
                                </MenuItem>
                            </Select>
                        </FormControl>

                        {data.triggerCondition !== "any-message" && (
                            <Autocomplete
                                multiple
                                freeSolo
                                options={[]} // sem sugestões, só livre
                                value={data.keywords}
                                onChange={(event, newValue) => {
                                    handleChange("keywords", newValue)
                                }}
                                renderTags={(value, getTagProps) =>
                                    value.map((option, index) => (
                                        <Chip
                                            variant="outlined"
                                            label={option}
                                            {...getTagProps({ index })}
                                            key={index}
                                        />
                                    ))
                                }
                                renderInput={(params) => (
                                    <TextField
                                        {...params}
                                        variant="outlined"
                                        label="Palavras-chave"
                                        placeholder="Digite e pressione Enter"
                                    />
                                )}
                            />
                        )}
                    </Stack>
                </DialogContent>

                <DialogActions>
                    <Button onClick={onCloseClick}>Cancelar</Button>
                    <Button
                        variant="contained"
                        onClick={() => {
                            onAddTrigger(data)
                            onCloseClick()
                        }}
                    >
                        Salvar
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    )
}

export default ModalTrigger
